import { Store } from "idb-keyval";

export const products = new Store("nutriciaProducts");
// export const categories = new Store('nutriciaCategories');
